module.exports = __webpack_public_path__ + "static/media/brav-logo.79c50553.png";